import { Button, Form } from "antd";
import { MaskedInput } from "antd-mask-input";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BundleList from "./bundle";
import { useDealer } from "../../../../tools/api";
import { validateInput } from "../../../../tools/tools";
import { switchPlanID } from "../../../../tools/services";

const SearchMsisdnBundle = ({ kitbundle, iccid }) => {
	const [t] = useTranslation("global");
	const { queryBundleSalesSimByMSISDN } = useDealer();
	//is Config Progress
	const [isProgressSearch, setIsProgressSearch] = useState(false);
	const [bundles, setBundles] = useState([]);
	const [msisdnBundle, setMsisdnBundle] = useState([]);
	const [fireSearch, setFireSearch] = useState(false);
	const handleSearchMsisdn = async (param) => {
		setIsProgressSearch(true);
		let payload = {
			msisdn: param.msisdn.replace(/ /g, ""),
			planid: switchPlanID().simPurchase,
		};
		setMsisdnBundle(payload.msisdn);
		let response = await queryBundleSalesSimByMSISDN(payload);

		if (response) {
			let resultCatID = [];
			response.forEach((element) => {
				let matchItem = resultCatID.filter((item) => item.bundleSalesSimId === element.bundleSalesSimId);
				if (matchItem.length === 0) {
					resultCatID.push(element);
				}
			});
			resultCatID = resultCatID.map((bundle) => {
				return {
					...bundle,
					attribute: response.filter((item) => bundle.bundleSalesSimId === item.bundleSalesSimId),
				};
			});
			resultCatID = resultCatID.sort((a, b) => {
				if (a.attributeOrderId > b.attributeOrderId) return 1;
				else return -1;
			});
			resultCatID = resultCatID.sort((a, b) => {
				if (a.bundleOrder > b.bundleOrder) return 1;
				else return -1;
			});
			setBundles(resultCatID);
		}
		setFireSearch(true);
		setIsProgressSearch(false);
	};
	return (
		<>
			<div className="holder-search-msisdn">
				<Form name="frm_SeachMsisdn" layout="inline" onFinish={handleSearchMsisdn}>
					<Form.Item
						name="msisdn"
						className="input-normal"
						rules={[validateInput({ t: t, validate: true, type: "msisdnFix" })]}
						extra={
							<>
								{bundles.length > 0 && (
									<div className="holder-result">
										<p>این شماره قابل خرید با طرح های آغازین زیر می باشد</p>
									</div>
								)}
							</>
						}>
						<MaskedInput
							className="msisdn-input"
							suffix={<i style={{ fontSize: "24px" }} className="icon-search"></i>}
							dir="ltr"
							mask="999 000 00 00"
							inputMode="numeric"
						/>
					</Form.Item>
					<Form.Item>
						<Button className="btn-normal btn-green" type="default" disabled={isProgressSearch} htmlType="submit">
							{isProgressSearch ? t("form.inProgress") : t("simcardpurchase.kit.searchInput")}
						</Button>
					</Form.Item>
				</Form>
			</div>
			<div className="g-list-bundle">
				<BundleList kitbundle={kitbundle} iccid={iccid} bundles={bundles} msisdn={[msisdnBundle]} fireSearch={fireSearch} />
			</div>
		</>
	);
};

export default SearchMsisdnBundle;
